export default {
  group_name_placeholder: 'Establecer el nombre del canal',
  group_purpose_placeholder: 'Establecer el prop\u00f3sito del canal',
};
